import { defineMessages } from "react-intl";
const messages = defineMessages({
    aiDiscoverabilityResultsPlaceholder: {
        id: "app.admin.aiDiscoverability.resultsPlaceholder",
        defaultMessage: "Yours results will appear here!",
    },
    aiDiscoverabilityResultLabel: {
        id: "app.admin.aiDiscoverability.resultLabel",
        defaultMessage: "Result {index}",
    },
});
export default messages;
